import * as React from "react";

function Preview() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3.5C6.46875 3.5 5.25 4.75 5.25 6.25C5.25 7.78125 6.46875 9 8 9C9.5 9 10.75 7.78125 10.75 6.25C10.75 4.75 9.5 3.5 8 3.5ZM8 7.5C7.28125 7.5 6.75 6.96875 6.75 6.25C6.75 5.5625 7.28125 5 8 5C8.6875 5 9.25 5.5625 9.25 6.25C9.25 6.96875 8.6875 7.5 8 7.5ZM8 0C3.5625 0 0 3.59375 0 8C0 12.4375 3.5625 16 8 16C12.4062 16 16 12.4375 16 8C16 3.59375 12.4062 0 8 0ZM8 14.5C6.53125 14.5 5.1875 14.0312 4.09375 13.2188C4.625 12.1562 5.6875 11.5 6.875 11.5H9.09375C10.2812 11.5 11.3438 12.1875 11.875 13.2188C10.7812 14.0312 9.4375 14.5 8 14.5ZM13 12.1562C12.1562 10.8438 10.7188 10 9.09375 10H6.875C5.25 10 3.8125 10.8438 2.96875 12.1562C2.03125 11.0312 1.5 9.59375 1.5 8C1.5 4.4375 4.40625 1.5 8 1.5C11.5625 1.5 14.5 4.4375 14.5 8C14.5 9.59375 13.9375 11.0312 13 12.1562Z"
        fill="black"
        fillOpacity="0.55"
      />
    </svg>
  );
}

export default Preview;
